import FilterDialog from './Dialog';
import { useSelector } from 'react-redux';
import FilterButton from '../../../../filter/FilterButton';

const FilterButtonClasses = ({ type = 'class', disabled }) => {
  const open = useSelector((state) => state?.filter?.[type]?.open || false);

  return (
    <>
      <FilterButton
        module={type}
        disabled={disabled}
        keysFilter={['yearLevel', 'subjectId', 'subject', 'teachersId', 'roles', 'rolesId']}
      />
      {open && <FilterDialog module={type} />}
    </>
  );
};
export default FilterButtonClasses;
